import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';

import { Label } from '@maxmilhas/hangar-components-atomic/public';
import { inputGroupStyle, inputStyle, iconClass, errorMessageStyle, labelWrapperStyle } from './style';

const TextArea = React.forwardRef((props, ref) => {
  const {
    children, label, labelCaption, name,
    hasError, errorMessage, icon, ...rest
  } = props

  return (
    <div className={css`${inputGroupStyle}`}>
      <div className={css`${labelWrapperStyle}`}>
        {label && (
          <Label name={name} caption={labelCaption}>
            {label}
          </Label>
        )}
      </div>

      <textarea
        className={css`${inputStyle(hasError, icon)}`}
        ref={ref}
        name={name}
        aria-describedby={`input-error-${name}`}
        aria-invalid={hasError}
        {...rest}
      />

      {(icon || hasError) && (
        <i className={`${css`${iconClass(hasError, label)}`} ${icon || (hasError && 'icon-max-communication-circle-close')}`} />
      )}

      {(hasError && errorMessage) && (
        <span id={`input-error-${name}`} aria-live="assertive" className={css`${errorMessageStyle}`}>
          {errorMessage}
        </span>
      )}
    </div>
  )
})

// TODO: Insert Props description for documentation
TextArea.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  name: PropTypes.string,
  errorMessage: PropTypes.string,
  id: PropTypes.string,
  hasError: PropTypes.bool,
  icon: PropTypes.string,
  labelCaption: PropTypes.string
}

TextArea.defaultProps = {
  label: null,
  name: null,
  id: null,
  hasError: false,
  errorMessage: null,
  icon: undefined,
  labelCaption: undefined
}

TextArea.displayName = 'TextArea'

export default TextArea
